import { useSelector } from 'react-redux';

import { EVENT_CONSTANTS } from '@/services';
import {
  selectUserAudienceRegions,
  selectUserCompliance,
  useFetchTrendingEpisodesQuery,
} from '@/store';

import { EpisodeCardCarousel } from '../EpisodeCardCarousel';

export const TrendingEpisodesCarousel = () => {
  const audienceRegions = useSelector(selectUserAudienceRegions);
  const compliance = useSelector(selectUserCompliance);

  const {
    data: trendingEpisodes = [],
    isLoading,
    isUninitialized,
  } = useFetchTrendingEpisodesQuery({
    compliance,
    audienceRegions,
    applyRelevanceBoost: true,
  });

  return (
    <>
      {trendingEpisodes?.length > 0 && (
        <EpisodeCardCarousel
          title="Trending Episodes"
          uKey="Trending Episodes"
          episodes={trendingEpisodes}
          isLoading={isLoading || isUninitialized}
          referrer={{
            page: EVENT_CONSTANTS.PAGE.DISCOVER,
          }}
        />
      )}
    </>
  );
};
